import React, { useRef, useState } from 'react';
import useBannerDownStyles from '../../styles/kozelBattle/bannerDown';
import battleVideo from '../../assets/videos/Kozel_battle.webm';

const BannerDown: React.FC = () => {
    const classes = useBannerDownStyles();
    const videoRef = useRef<HTMLVideoElement>(null);
    const [playing, setPlaying] = useState(false);

    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setPlaying(true);
        }
    };

    return (
        <div className={classes.wrapper}>
            <video
                ref={videoRef}
                className={classes.video}
                src={battleVideo}
                playsInline
            />
            {!playing && (
                <div className={classes.overlay}>
                    <p className={classes.title}>
                        Urmărește Spotul Kozel<br />Mereu Împreună
                    </p>
                    <button
                        className={classes.playButton}
                        onClick={handlePlay}
                        aria-label="Play video"
                    >
                        <span className={classes.playIcon} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default BannerDown;